import { ProjectRoleNEW } from ':cloud/types/service_proto';
import { OrganizationRole } from ':cloud/types/ts_types';

export const ROLES: OrganizationRole[] = ['ROLE_OWNER', 'ROLE_ADMIN', 'ROLE_USER'];
export const OWNER_ROLE: OrganizationRole[] = ['ROLE_OWNER'];
export const OWNER_ADMIN_ROLES: OrganizationRole[] = ['ROLE_OWNER', 'ROLE_ADMIN'];
export const ADMIN_USER_ROLES: OrganizationRole[] = ['ROLE_ADMIN', 'ROLE_USER'];

// New Project Roles
// eslint-disable-next-line import/no-unused-modules -- temp disable for preventing change owner'
export const PROJECT_ROLES: ProjectRoleNEW[] = [
  ProjectRoleNEW.Owner,
  ProjectRoleNEW.Admin,
  ProjectRoleNEW.UserNEW,
];

// eslint-disable-next-line import/no-unused-modules
export const PROJECT_OWNER_ADMIN_ROLES: ProjectRoleNEW[] = [
  ProjectRoleNEW.Owner,
  ProjectRoleNEW.Admin,
];

export const PROJECT_ADMIN_USER_ROLES: ProjectRoleNEW[] = [
  ProjectRoleNEW.Admin,
  ProjectRoleNEW.UserNEW,
];
